import { pickExpert, updateAvailableTypeList } from 'FRONTEND/reducers/bookingSlice';
import { listError, listRequest, listSuccess } from 'FRONTEND/reducers/slotSlice';
import * as slotApi from 'FRONTEND/utils/backendApi/slotApi';
import { BOOKABLE_APPOINTMENT_TYPE_LIST, FormTypes } from 'FRONTEND/utils/constants';


const slotMiddleware = (store) => (next) => (action) => {
  switch (action.type) {
    case listRequest.toString():
      next(action);
      slotApi.getSlots({
        expertIdList: action.payload.expertIdList,
        startDate: action.payload.startDate,
        appointmentType: action.payload.appointmentType,
      }).then((slots) => {
        store.dispatch(listSuccess({ slots }));
      }).catch((error) => store.dispatch(listError({ error: error.message })));
      return;

    case pickExpert.toString(): {
      const { booking } = store.getState();
      const isPatientForm = booking.formType === FormTypes.PATIENT_FORM;
      const isLocationForm = booking.formType === FormTypes.LOCATION_FORM;
      if (action.payload.id && !isPatientForm && !isLocationForm) {
        slotApi.getSlots({
          expertIdList: [action.payload.id],
          startDate: new Date().toISOString(),
        }).then((slots) => {
          const availableTypeMap = {};
          slots.some((slot) => {
            slot.appointmentTypeList.forEach((appointmentType) => {
              if (BOOKABLE_APPOINTMENT_TYPE_LIST.includes(appointmentType)) {
                availableTypeMap[appointmentType] = true;
              }
            });
            return BOOKABLE_APPOINTMENT_TYPE_LIST.every((bookableAppointmentType) => availableTypeMap[bookableAppointmentType]);
          });
          store.dispatch(updateAvailableTypeList({ availableTypeList: Object.keys(availableTypeMap) }));
        });
      }
      next(action);
      return;
    }
    default:
      return next(action);
  }
};

export default slotMiddleware;
